import React, { useState } from 'react';
import AsyncSelect from 'react-select/async';
import School from '../../../models/School';

const selectStyles = {
    control: (base, state) => ({
        ...base,
        minHeight: '42px',
        height: '42px',
        borderRadius: '8px',
        borderColor: state.isFocused ? '#3b82f6' : '#cbd5e1',
        borderWidth: '2px',
        boxShadow: state.isFocused ? '0 0 0 3px rgba(59, 130, 246, 0.1)' : 'none',
        fontSize: '16px',
        backgroundColor: 'white',
        '&:hover': {
            borderColor: state.isFocused ? '#3b82f6' : '#cbd5e1'
        }
    }),
    valueContainer: (base) => ({
        ...base,
        height: '38px',
        padding: '0 12px'
    }),
    input: (base) => ({
        ...base,
        margin: '0',
        padding: '0',
        fontSize: '16px',
        color: '#334155'
    }),
    indicatorsContainer: (base) => ({
        ...base,
        height: '38px'
    }),
    placeholder: (base) => ({
        ...base,
        color: '#94a3b8',
        fontSize: '16px'
    }),
    singleValue: (base) => ({
        ...base,
        color: '#334155',
        fontSize: '16px'
    }),
    option: (base, state) => ({
        ...base,
        backgroundColor: state.isSelected ? '#3b82f6' : state.isFocused ? '#f1f5f9' : 'white',
        color: state.isSelected ? 'white' : '#334155',
        fontSize: '16px',
        padding: '10px 12px'
    }),
    menu: (base) => ({
        ...base,
        borderRadius: '8px',
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
        zIndex: 9999
    })
};

// Load schools - same pattern as DprojectForm
const loadSchoolOptions = (value, callback) => {
    School.where({
        name: { match_distinct: value || 'SP_EMPTY' }
    })
        .all()
        .then((res) => {
            const options = [{ label: 'All', value: '' }];
            res.data.forEach((e) => {
                if (e.name) {
                    const label = e.cityName ? `${e.name} (${e.cityName})` : e.name;
                    options.push({ label, value: e.id });
                }
            });
            callback(options);
        })
        .catch((error) => {
            console.error('Error loading schools:', error);
            callback([{ label: 'All', value: '' }]);
        });
};

const SchoolSelect = ({ selectedId, selectedName }) => {
    const initialValue = selectedId
        ? { label: selectedName || '', value: selectedId }
        : { label: 'All', value: '' };

    const [selected, setSelected] = useState(initialValue);

    const handleChange = (option) => {
        if (!option) {
            setSelected({ label: 'All', value: '' });
        } else {
            setSelected(option);
        }
    };

    return (
        <div className="filter-field">
            <label>School</label>
            <input
                type="hidden"
                name="q[school_id_eq]"
                value={selected?.value || ''}
                readOnly
            />
            <AsyncSelect
                cacheOptions
                defaultOptions
                value={selected}
                loadOptions={loadSchoolOptions}
                onChange={handleChange}
                styles={selectStyles}
                placeholder="All"
                isClearable={false}
            />
        </div>
    );
};

export default SchoolSelect;
